import React from "react"
import { Grid } from "@material-ui/core"
import styles from '../styles.module.css'
import { BlockHistory } from "../../../models/RobocallBlocks/BlockedNumber"

interface IProps {
    history: BlockHistory[]
}

/**
 * Append-only audit trail for one number.
 *
 * This is where the timeline actually lives: spam_calls verdict rows are mutable (they
 * escalate in place), so they cannot answer "when did this happen" or "who decided it".
 *
 * The `action` JSON carries per-transition context — veto_strength, term_hours, call_sid
 * and so on — so anything beyond action/comment is rendered generically rather than being
 * dropped, otherwise the reason a decision was taken is invisible.
 */
const ActionsList = (props: IProps) => {
    if (props.history.length === 0) {
        return (
            <Grid item xs={12}>
                <div className={styles.Empty}>No history yet.</div>
            </Grid>
        )
    }

    const context = (action: any): string => {
        if (!action) {
            return ''
        }
        return Object.keys(action)
            .filter((k) => k !== 'action' && k !== 'comment')
            .filter((k) => action[k] !== null && action[k] !== '' && action[k] !== undefined)
            .map((k) => `${k}=${typeof action[k] === 'object' ? JSON.stringify(action[k]) : action[k]}`)
            .join(' · ')
    }

    return (
        <>
            {props.history.map((row) => (
                <React.Fragment key={row.id}>
                    <Grid item xs={3}>
                        <div className={styles.HistoryRow}>{row.created_at}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className={styles.HistoryRow}>
                            <span className={styles.HistoryAction}>
                                {row.action?.action || '—'}
                            </span>
                            <div className={styles.EvidenceMuted}>{context(row.action)}</div>
                        </div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className={styles.HistoryRow}>{row.action?.comment || '—'}</div>
                    </Grid>
                    <Grid item xs={3}>
                        <div className={styles.HistoryRow}>
                            {row.user?.email || (row.user_id ? `user ${row.user_id}` : 'automatic')}
                        </div>
                    </Grid>
                </React.Fragment>
            ))}
        </>
    )
}

export default ActionsList
